import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {catchError, delay, exhaustMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import * as fromAuthActions from './auth.actions';
import {AuthActions, AuthActionTypes, LoginFailure, LoginSuccess, Set} from './auth.actions';
import {AuthService} from './auth.service';
import {decodeToken} from '../../services/utils';
import {initialState} from './auth.reducer';
import {Router} from '@angular/router';


@Injectable()
export class AuthEffects {

    @Effect()
    Login$ = this.actions$.pipe(
        ofType(AuthActionTypes.Login),
        map((action: any) => action.payload),
        exhaustMap((credentials) =>
            this._svc.login(credentials.username, credentials.password)
                .pipe(
                    map(data => new LoginSuccess({ token: data.token, profile: decodeToken(data.token) })),
                    catchError(error => of(new LoginFailure(error))))
        )
    );

    @Effect()
    CheckAuth$ = this.actions$.pipe(
        ofType(AuthActionTypes.CheckAuth),
        map((action: any) => action.payload),
        exhaustMap((token) =>
            this._svc.checkAuth(token)
                .pipe(
                    map(data => new fromAuthActions.CheckAuthSuccess({ token: token, profile: decodeToken(token) })),
                    catchError(error => of(new fromAuthActions.CheckAuthFailure(error))))
        )
    );

    @Effect({dispatch: false})
    LoginSuccess$ = this.actions$.pipe(
        ofType(AuthActionTypes.LoginSuccess),
        map(action => action.payload),
        exhaustMap((auth: any) => {
            localStorage.setItem('token', auth.token);
            return this.router.navigate(['/file-manager']);
        })
    );

    @Effect()
    CheckAuthSuccess$ = this.actions$.pipe(
        ofType(AuthActionTypes.CheckAuthSuccess),
        map(action => action.payload),
        exhaustMap((auth: any) => {
            localStorage.setItem('token', auth.token);
            return of(new Set({success: true}));
        })
    );

    @Effect()
    LoginFailure$ = this.actions$.pipe(
        ofType<LoginSuccess | fromAuthActions.CheckAuthFailure>(AuthActionTypes.LoginFailure, AuthActionTypes.CheckAuthFailure),
        map(action => action.payload),
        exhaustMap((auth: any) => {
            localStorage.setItem('token', null);
            return of(new Set({success: false}))
        })
    );

    @Effect()
    Logout$ = this.actions$.pipe(
        ofType(AuthActionTypes.Logout),
        map((action: any) => action.payload),
        exhaustMap((token) =>
            this._svc.doLoad('auth/logout')
                .pipe(
                    map(data => new fromAuthActions.LogoutSuccess({})),
                    catchError(error => of(new fromAuthActions.LogoutFailure(error))))
        )
    );

    @Effect()
    LogoutSuccess$ = this.actions$.pipe(
        ofType<fromAuthActions.LogoutFailure | fromAuthActions.LogoutSuccess>(AuthActionTypes.LogoutSuccess, AuthActionTypes.LogoutFailure),
        map(action => action.payload),
        tap((auth: any) => {
            localStorage.removeItem('token');
            window.location.href = "https://fileshare.triplehenterprises.net/login"
            //window.location.href = "http://fileshare.codepillars.com/login"
            //return of(new Set(initialState)).pipe(delay(200))
        })
    );

    @Effect()
    ResetSuccess$ = this.actions$.pipe(
        ofType<LoginSuccess | LoginFailure>(AuthActionTypes.LoginFailure, AuthActionTypes.LoginSuccess),
        map(action => action.payload),
        exhaustMap((auth: any) => of(new Set({success: undefined})).pipe(delay(200)))
    );

    constructor(private actions$: Actions<AuthActions>, private _svc: AuthService, private router: Router) {
    }

}
